// src/components/ProtectedRoute.jsx
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { checkAuthAsync } from '../features/auth/authActions';
import { selectIsAuthenticated, selectIsCheckingAuth, logout } from '../features/auth/authSlice';
import Loader from '../components/Loader'; // Imported clean tailwind element

export default function ProtectedRoute() {
  const dispatch = useDispatch();
  const location = useLocation();
  
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isCheckingAuth = useSelector(selectIsCheckingAuth);

  useEffect(() => {
    const validateSession = () => {
      if (localStorage.getItem('token')) dispatch(checkAuthAsync());
      else dispatch(logout());
    };
    const handleStorage = event => {
      if (event.key === null || event.key === 'token') validateSession();
    };
    const handlePageShow = event => {
      if (event.persisted) validateSession();
    };
    validateSession();
    window.addEventListener('storage', handleStorage);
    window.addEventListener('pageshow', handlePageShow);
    return () => {
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [dispatch]);

  // Renders the Tailwind CSS loader view smoothly 
  if (isCheckingAuth) {
    return <Loader message="Validating authentication..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}

